<template>
  <div
    v-if="!isWarningDismissed"
    class="mx-4 mt-3 flex items-center justify-between gap-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900"
    role="status"
    aria-live="polite"
  >
    <span
      >Please note that only the most recent, 500 records will be downloaded as the data on this table exceeds the
      maximum downloadable limit. For large data exports, please contact support@layup.co.za for further
      assistance.</span
    >
    <button
      type="button"
      class="rounded p-1 text-amber-900 hover:bg-amber-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
      aria-label="Close loading warning"
      @click="onCloseWarning"
    >
      <CircleX class="h-4 w-4" />
    </button>
  </div>
</template>
<script setup lang="ts">
import { CircleX } from 'lucide-vue-next';
import { ref } from 'vue';

const isWarningDismissed = ref(false);
const onCloseWarning = () => {
  isWarningDismissed.value = true;
};
</script>
